"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactIdSwiper = _interopRequireDefault(require("react-id-swiper"));

require("swiper/css/swiper.css");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _excluded = ["children", "className"];
var config = {
  slidesPerView: 'auto',
  slidesPerColumnFill: 'row',
  centeredSlides: true,
  loop: false,
  longSwipesRatio: 2,
  threshold: 1
};

var SearcherDateCarousel = function SearcherDateCarousel(_ref) {
  var children = _ref.children,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledSlider, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(_reactIdSwiper["default"], (0, _extends2["default"])({}, config, props), children)));
};

SearcherDateCarousel.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
SearcherDateCarousel.defaultProps = {
  className: ''
};

var StyledSlider = _styledComponents["default"].div.withConfig({
  displayName: "SearcherDateCarousel__StyledSlider",
  componentId: "sc-3ndx0x-0"
})(["padding-top:10px;margin-bottom:20px;background:", ";border-radius:", ";height:100px;position:relative;z-index:1;"], function (props) {
  return props.theme.colors.white;
}, function (props) {
  return "0 0 ".concat(props.theme.shape.borderRadiusBig, " ").concat(props.theme.shape.borderRadiusBig);
});

SearcherDateCarousel.StyledSlider = StyledSlider;

var _default = /*#__PURE__*/_react["default"].memo(SearcherDateCarousel);

exports["default"] = _default;